import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';

const Header = ({ onShopNowClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleShopNow = () => {
    // Always go to shop page for retail orders
    navigate('/shop');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/ejvn3pae_High%20Res%20Logo.jpg" 
              alt="Original Bull Logo" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation - Centered */}
          <div className="hidden md:flex items-center justify-center flex-1 space-x-8">
            <Link to="/" className="text-gray-700 hover:text-red-700 font-medium transition-colors">
              Home
            </Link>
            <button onClick={() => scrollToSection('products')} className="text-gray-700 hover:text-red-700 font-medium transition-colors">
              Products
            </button>
            <Link to="/steak" className="text-gray-700 hover:text-red-700 font-medium transition-colors">
              Steak Range
            </Link>
            <button onClick={() => scrollToSection('heritage')} className="text-gray-700 hover:text-red-700 font-medium transition-colors">
              Heritage
            </button>
            <Link to="/wholesale" className="text-gray-700 hover:text-red-700 font-medium transition-colors">
              Wholesale
            </Link>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-red-700 font-medium transition-colors">
              Contact
            </button>
          </div>

          {/* Shop Now Button */}
          <div className="hidden md:block">
            <button 
              onClick={handleShopNow}
              className="bg-red-700 text-white px-6 py-2 rounded-md hover:bg-red-800 transition-colors font-medium"
            >
              Shop Now
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <Link to="/" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={() => setMobileMenuOpen(false)}>
              Home
            </Link>
            <button onClick={() => { scrollToSection('products'); setMobileMenuOpen(false); }} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50">
              Products
            </button>
            <Link to="/steak" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={() => setMobileMenuOpen(false)}>
              Steak Range
            </Link>
            <button onClick={() => { scrollToSection('heritage'); setMobileMenuOpen(false); }} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50">
              Heritage
            </button>
            <Link to="/wholesale" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={() => setMobileMenuOpen(false)}>
              Wholesale
            </Link>
            <button onClick={() => { scrollToSection('contact'); setMobileMenuOpen(false); }} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50">
              Contact
            </button>
            <button onClick={() => { handleShopNow(); setMobileMenuOpen(false); }} className="mx-4 mt-2 w-[calc(100%-2rem)] bg-red-700 text-white px-6 py-2 rounded-md hover:bg-red-800 transition-colors font-medium block text-center">
              Shop Now
            </button>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;